<template>
  <v-snackbar v-model="model" :timeout="timeout" @update:model-value="onClose">
    <slot></slot>

    <template v-slot:actions>
      <v-btn color="blue" variant="text" @click="onClose(false)">Close</v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const emit = defineEmits(['update:show', 'timeout']);
const props = defineProps({
  show: Boolean,
  timeout: {
    type: Number,
    default: 3000,
  },
});

// Proxy prop `show` into a writable computed
const model = computed({
  get: () => props.show,
  set: (val: boolean) => emit('update:show', val),
});

const onClose = (val: boolean) => {
  if (!val) {
    emit('timeout');
    emit('update:show', false); // close snackbar
  }
};
</script>
